import React, { useEffect, useState } from "react";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from "dayjs";

const DateTimeField = React.forwardRef(
    (
        {
            label,
            errorMsg,
            value,
            onChangeInput,
            sizeRange,
            allowedSizes,
            containerClass,
            showKeyboard = true,
            dateFormat,
            ...restProps
        },
        ref
    ) => {
        const [open, setOpen] = useState(false);
        const [format, setFormat] = useState(['day', 'month', 'year']);
        const dateFr={"MMM":"month","YY":'year',"MM":"month","YYYY":'year',"DD":'day'}

        useEffect(() => {
            if(dateFormat){
                let fr=[]
                let arr=dateFormat.split("/").join("-").split("-")
                for (let index = 0; index < arr.length; index++) {
                    fr[index] = dateFr[arr[index]];
                }
                setFormat(fr)
            }
        },[dateFormat]);
        
        return (
            <div
                className={`input-field-sec ${errorMsg ? "error-field" : ""} ${
                    containerClass || ""
                }`}
            >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        open={open}
                        onOpen={() => setOpen(true)}
                        onClose={() => setOpen(false)}
                        inputRef={ref}
                        format={dateFormat?dateFormat:"DD-MMM-YY"}
                        helperText={label}
                        value={value ? dayjs(new Date(value).toISOString().split("T")[0]) : ""}
                        onChange={e => onChangeInput(new Date(e).valueOf())}
                        variant="outlined"
                        views={format}
                        {...restProps}
                        slotProps={{
                            textField: {
                              helperText: label?label:"",
                              onClick: () => setOpen(true), 
                            }
                        }}
                    />
                </LocalizationProvider>
                {errorMsg && <span className="helperTextError">{errorMsg}</span>}
            </div>
        );
    }
);

export default DateTimeField;
